import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const MinusIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path d="M19 13H5v-2h14v2z"></path>
  </SvgIcon>
);

export default MinusIcon;
